import React from 'react'
import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import propTypes from 'prop-types'


export default function Loader(props) {
  return (
    <Transition
      as={React.Fragment}
      show={props.active}
      enter='transition duration-3000 ease-out'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition duration-3000 ease-out'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <span className={classNames(
        { 'absolute w-full h-full flex items-center justify-center': props.center},
        props.containerClassName,
      )}>
        <span className={classNames([
          'h-5 w-5 transform transition-all block',
          {
            'text-primary-600 relative': ! props.className
          },
          props.className,
        ])}>
          <svg
            className='animate-spin w-full h-full'
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
          >
            <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
            <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
          </svg>
        </span>
      </span>
    </Transition>
  )
}


Loader.propTypes = {
  active: propTypes.bool.isRequired,
  className: propTypes.string,
  containerClassName: propTypes.string,
  center: propTypes.bool,
}
